export interface SetPasscodePayload {
    key: string,
    value: string,
}
export const SET_PASSCODE_DIGIT = 'SET_PASSCODE_DIGIT';
export const CLEAR_ALL_PASSCODE_DIGITS = 'CLEAR_ALL_PASSCODE_DIGITS';
